import { fetchData } from './dataFetching';
import { transformData } from './dataTransformation';

const holeColumns = {
  'Hole No': 'Hole_ID',
  'X': 'NAT_East',
  'Y': 'NAT_North',
  'Z': 'NAT_RL',
  'Azimuth': 'Collar_Azimuth',
  'Dip': 'Collar_Dip',
  'Depth': 'Max_Depth',
};

const assayColumns = {
  'HoleID': 'Hole_ID',
  'from': 'Depth_From',
  'to': 'Depth_To',
  'grade': 'Au_ppm',
};

const constants = [205200, 1180, 7975000];

class HoleDataCache {
  constructor() {
    this.cache = new Map();
    this.loadingPromises = new Map();
  }

  async getData(hole_url, assay_url) {
    const cacheKey = `${hole_url}_${assay_url}`;
    
    // Return cached data if available
    if (this.cache.has(cacheKey)) {
      return this.cache.get(cacheKey);
    }

    // Return existing loading promise if already loading
    if (this.loadingPromises.has(cacheKey)) {
      return this.loadingPromises.get(cacheKey);
    }

    // Start loading data
    const loadingPromise = this.loadData(hole_url, assay_url);
    this.loadingPromises.set(cacheKey, loadingPromise);

    try {
      const data = await loadingPromise;
      this.cache.set(cacheKey, data);
      this.loadingPromises.delete(cacheKey);
      return data;
    } catch (error) {
      this.loadingPromises.delete(cacheKey);
      throw error;
    }
  }

  async loadData(hole_url, assay_url) {
    const data = await fetchData(hole_url, assay_url, holeColumns, assayColumns);
    const transformed = transformData(data, holeColumns, assayColumns, constants);
    return transformed;
  }

  // Get filtered data for specific dataset and hole type
  getFilteredData(hole_url, assay_url, dataset, holeType) {
    const cacheKey = `${hole_url}_${assay_url}`;
    const allData = this.cache.get(cacheKey);
    
    if (!allData) {
      return null;
    }

    // Filter the data based on dataset and hole type
    const filteredData = {};
    Object.keys(allData).forEach(holeId => {
      const holeData = allData[holeId];
      if (holeData.data.DataSet === dataset && holeData.data.Hole_Type === holeType) {
        filteredData[holeId] = holeData;
      }
    });

    return filteredData;
  }

  // Clear cache if needed
  clearCache() {
    this.cache.clear();
    this.loadingPromises.clear();
  }
}

// Export singleton instance
export const holeDataCache = new HoleDataCache();
